var vms = vms || {};
vms.project = vms.project || {};


/* Created on 2017_01_26 by Davor
* shows or hides closed tasks
* vsmClosedToggle is a state flag
*/
var vsmClosedToggle = false;
vms.project.vsmToggleClosedTask = function () {
    var $closedRows = $(".t_status_Y, .t_status_H, .t_status_C");
    if ($closedRows.first().attr("style") == "display:none !important") {
        $closedRows.show();
        vsmClosedToggle = false;
    } else {
        $closedRows.attr("style", "display:none !important");
        vsmClosedToggle = true;
    }
}

/* Created on 2017_01_26 by Davor
* show/hide child tasks
*/
vms.project.vsmTogleTask = function (pId, pThis) {
    if ($(pThis).parent().hasClass("t_child_hidden")) {
        $(".t_group[task_id='" + pId + "']").show();
		$(".lx-hint-container[task_id='" + pId + "']").removeClass("white");
		$(".lx-hint-container[task_id='" + pId + "']").addClass("blue");
        $(pThis).parent().removeClass("t_child_hidden");
    } else {
        $(".t_group[task_id='" + pId + "']").hide();
        $(pThis).parent().addClass("t_child_hidden");
		$(".lx-hint-container[task_id='" + pId + "']").removeClass("blue");
		$(".lx-hint-container[task_id='" + pId + "']").addClass("white"); 
    }
}

/* Created on 2017_01_26 by Davor
* gets project task list
*/
vms.project.lxTaskList = function (pProject, pOwner, pVessel) {
    var vPage = $v("pFlowStepId");
    if (vPage == 29 || vPage == 58 || vPage == 1)
        window.location.reload();
    else if (vPage == 344)
        refresh_ir_report();
    else
        apex.server.process("TASK_LIST", {
            x01: pProject,
            x02: pOwner,
            x03: pVessel
        }, {
                dataType: "html",
                success: function (pData) {
                    $("#lx-task-list").html(pData);
                    lxHint();
                    if (vsmClosedToggle) { vsmToggleClosedTask(); }
                }
            });
}

vms.project.pushTask = function (pId, pVslId, pType, pThis, pProjectId, pUnpush) {
    let conf = true;
    if (pType == "R") {
        conf = confirm("This action will copy job to Planned Refit!");
    } /*else {
        var conf = (pUnpush ? confirm("This action will remove the job from Pushed List!") : confirm("This action will add the job to Pushed List!") );
    }*/
    if (conf) {
        apex.server.process("PUSH_TASK", {
            x01: pId,
            x02: pVslId,
            x03: (pUnpush ? 1 : 0),
            x04: pProjectId
        }, {
                dataType: "text",
                success: function (pData) {
                    if (pData.trim() == "OK") {
                        let vRegionId = $(pThis).closest(".t-Region").attr("id");
                        if (pUnpush)
                            $(pThis).replaceWith('<div style="cursor:pointer;" onclick="vms.project.pushTask('+pId+','+pVslId+',\''+pType+'\',this);">FLAG</div>');
                        else
                            $(pThis).replaceWith('<div style="cursor:pointer;" onclick="vms.project.pushTask('+pId+','+pVslId+',\''+pType+'\',this, true);">CLEAR</div>');
                        if (pType == 'R') $('div.taskPushList').on('dialogclose', function (event) { location.reload(); });
                        // refresh IR
                        apex.region(vRegionId).refresh();
                    } else alert(pData);
                }
            });
    }
}

/* created on: 2022_10_28 by: Miroslav
*  updated on: ...
*/
vms.project.signOffTask = function (pTaskId, pSign, pThis) {
        apex.server.process("taskSign"
        , { x01: pTaskId, x02: pSign }
        , {
            dataType: "text",
            success: function (d) {
				if (pSign == 0) {
					$(pThis).replaceWith('<div style="cursor:pointer;" onclick="vms.project.signOffTask('+ pTaskId + ', 1, this);">SIGN<br>OFF</div>');
				}
				else {
					$(pThis).replaceWith('<div style="cursor:pointer;" onclick="vms.project.signOffTask('+ pTaskId + ', 0, this);">REMOVE<br>SIGNATURE</div>');
				}
            }
        });
}

/* created on: 2015_11_16 by: Davor
*  updated on: ...
*/
function taskClosePopup(pId, pClose, pProjType, pOwnType, pThis, pMeasure, pParts, pAlert, pNc) {
    var open = false;
    if ($(pThis).parent().find(".tcp_popup").length) open = true;
    //$("input[name='task_option']").unbind();
    $(".tcp_popup").replaceWith("");
    $(".a_task_hide_open").removeClass("a_task_hide_open");
    if (!open) {
        var vHtml = '<div class="tcp_popup">' +
            '<div class="tcp_title" onclick="$(this).parent().remove();$(\'.a_task_hide_open\').removeClass(\'a_task_hide_open\');">' +
            '<i class="far fawe-times-circle"></i></div>' +
            '<div class="tcp_container">';
        /*if (pMeasure){
            vHtml = vHtml + 'Please enter Measured value before closing the task!';
        }else if (pParts){
            vHtml = vHtml + 'Please submit used spare parts before closing the task!';
        }else{*/
        if (pAlert) {
            vHtml += '<div class="tcp_option"><input id="tcpOpt_5" type="radio" name="task_option" value="Y"><label for="tcpOpt_5"> Acknowledged, no need for further action!</label></div>' +
                '<div class="tcp_option"><input id="tcpOpt_6" type="radio" name="task_option" value="NT"><label for="tcpOpt_6"> Acknowledged, further action is required!</label></div>';
        } else {
            vHtml += '<div class="tcp_option"><input style="cursor:pointer;" id="tcpOpt_1" type="radio" name="task_option" value="Y"><label style="cursor:pointer;" for="tcpOpt_1"> Sign Off</label></div>';
            if (pProjType == 'S' && pOwnType == 'VSL' && !pNc) {
                vHtml += '<div class="tcp_option"><input style="cursor:pointer;" id="tcpOpt_7" type="radio" name="task_option" value="P"><label style="cursor:pointer;" style="cursor:pointer;"  for="tcpOpt_7"> Deficiency for Port Trunaround</label></div>' +
                    '<div class="tcp_option"><input style="cursor:pointer;" id="tcpOpt_8" type="radio" name="task_option" value="R"><label style="cursor:pointer;" for="tcpOpt_8"> Deficiency for Major Dockside Refit</label></div>' +
                    '<div class="tcp_option"><input style="cursor:pointer;" id="tcpOpt_9" type="radio" name="task_option" value="D"><label style="cursor:pointer;" for="tcpOpt_9"> Deficiency for Drydocking</label></div>';
				/*}else if (pOwnType == 'COM'){
                    vHtml +=        '<div class="tcp_option"><input style="cursor:pointer;" id="tcpOpt_2" type="radio" name="task_option" value="C"><label style="cursor:pointer;" for="tcpOpt_2">Cancel</label></div>'+
                                    '<div class="tcp_option"><input style="cursor:pointer;" id="tcpOpt_3" type="radio" name="task_option" value="H"><label style="cursor:pointer;" for="tcpOpt_3">Put On Hold</label></div>';*/
            } else {
                setTaskStatus(pId, pThis, "Y");
                $(pThis).closest(".vh_activity").remove();
                return;
            }
        }
        //}
        vHtml += '</div>' +
            '</div>';
        $(pThis).parent().addClass("a_task_hide_open").append(vHtml);
        $("input[name='task_option'][value='" + pClose + "']").prop("checked", true);
        $("input[name='task_option']").click(function () { setTaskStatus(pId, this, this.value); });
    }
}

/* created on: 2015_11_16 by: Davor
*  updated on: ...
*/
function setTaskStatus(pId, pThis, pSts, pDate) {
    if (pSts == 'NT') {
        getCreateTaskLink(pId);
        if ($("#lx-task-list").length) {
            // Ship operation task list
            lxTaskList($v("taskListProjectId"));
        } else {
            if (pSts == "Y") $(pThis).closest(".vh_activity").remove();
            else $(pThis).closest(".a_task_hide").find(".a_task_sts").attr("onclick", "taskClosePopup(" + pId + ", '" + pSts + "', this);");
        }
    } else if (!pDate && (pSts == 'P' || pSts == 'R' || pSts == 'D')) {
        console.log(pThis);
        let vDialog = '<div class="vsmSendToNc">'
                    + '<div class="sendToNcContent"><p>Deferred to: <input type="text" class="datepicker apex-item-text apex-item-datepicker" id="deferredDate" value="'
                    + $(pThis).closest(".tcp_popup").siblings('div').data("date") +'" maxlength="2000" size="15" value="" autocomplete="off" /></p></div>'
                    + '</div>';
        $(vDialog).dialog({
                                modal: true,
                                resizable: false,
                                width: 'auto',
                                dialogClass: "vsmBtns",
                                title: 'Enter Date',
                                buttons: [{text: "OK",  click: function() {
                                    let date = $v("deferredDate");
                                    $("#deferredDate").datepicker("destroy" );
                                    $(this).dialog("destroy");
                                    setTaskStatus(pId, pThis, pSts, date);
                                }}]
                            });
        apex.widget.datepicker("#deferredDate",{
            "buttonImageOnly":false,
            "buttonText":"\u003Cspan class=\u0022a-Icon icon-calendar\u0022\u003E\u003C\u002Fspan\u003E\u003Cspan class=\u0022u-VisuallyHidden\u0022\u003EPopup Calendar: \u003Cspan\u003E",
            "showTime":false,
            /*"time24h":true,
            "timeFormat":"HH:ii",
            "defHour":vLog.hour,
            "defMinute":vLog.min,*/
            "defaultDate":new Date(),
            "showOn":"button",
            "showOtherMonths":false,
            "changeMonth":false,
            "changeYear":false},
            "mm\u002Fdd\u002Fyy",
            "en");
        $("#deferredDate").siblings("button").removeClass().addClass('ui-datepicker-trigger a-Button a-Button--calendar');
        console.log('deferred date dialog opened!');
    } else {
        console.log('Submit:' + pId +', '+ pSts +', '+ pDate);
        $.ajax({
            url: "wwv_flow.show",
            dataType: "html",
            traditional: true,
            cache: false,
            type: "POST",
            data: {
                p_flow_id: $v("pFlowId"),
                p_flow_step_id: $v("pFlowStepId"),
                p_instance: $v("pInstance"),
                p_request: "APPLICATION_PROCESS=setTaskStatus",
                x01: pId,
                x02: pSts,
                x03: pDate
            },
            success: function (d) {
                if ($("#lx-task-list").length) {
                    // Ship operation task list
                    //lxTaskList($v("taskListProjectId"));
                    $(pThis).closest(".t_task").remove();
                } else {
                    if (pSts == "Y" || pSts == 'P' || pSts == 'R' || pSts == 'D') $(pThis).closest(".vh_activity").remove();
                    else $(pThis).closest(".a_task_hide").find(".a_task_sts").attr("onclick", "taskClosePopup(" + pId + ", '" + pSts + "', this);");
                }
                $(".tcp_popup").replaceWith("");
                apex.region("ir1").refresh();
                //$(".a_task_hide_open").removeClass("a_task_hide_open");
            }
        });
    }
}

var vsmToggleClosedTask = vms.project.vsmToggleClosedTask;
var vsmTogleTask = vms.project.vsmTogleTask;
var lxTaskList = vms.project.lxTaskList;
var vmPushTask = vms.project.pushTask;